/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Delete_TitleInputs */

const en_lifecycle_delete_title = /** @type {(inputs: Lifecycle_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
};

const de_lifecycle_delete_title = /** @type {(inputs: Lifecycle_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} löschen?`)
};

/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Lifecycle_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_title = /** @type {((inputs: Lifecycle_Delete_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_title(inputs)
	return en_lifecycle_delete_title(inputs)
});